import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import io from "socket.io-client";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/responsive.scss";
import "./assets/css/styles.scss";
import WheelContent from "./Wheel/WheelContent";
import { adminBaseURL, baseURL, key } from "./config";
import { createDemoSocket, DEMO_USER, DEMO_GAME_COIN } from "./demoSocket";

const queryParams = new URLSearchParams(window.location.search);
const userId = queryParams.get("id");
const isDemoMode = !baseURL;

axios.defaults.headers.common["key"] = key;

const defaultCoinNumbers = [100, 200, 300, 400, 500];

function App() {
  const socketRef = useRef();
  const [socket, setSocket] = useState(null);
  const [userData, setUserData] = useState();
  const [settingData, setSettingData] = useState();
  const [gameCoin, setGameCoin] = useState(defaultCoinNumbers);

  useEffect(() => {
    if (isDemoMode) {
      const demoSocket = createDemoSocket();
      socketRef.current = demoSocket;
      setSocket(demoSocket);
      demoSocket.on("start", (data) => setUserData(data));
      demoSocket.on("user", (user) => {
        if (user && Object.values(user).length > 0) setUserData(user);
      });
      demoSocket.emit("startGame", {});
      setGameCoin(DEMO_GAME_COIN);
      return () => demoSocket.disconnect();
    }

    if (userId) {
      const liveSocket = io.connect(baseURL, {
        transports: ["websocket", "polling", "flashsocket"],
        query: { globalRoom: userId },
      });
      socketRef.current = liveSocket;
      liveSocket.on("connect", () => {
        if (liveSocket.connected === true) {
          setTimeout(() => {
            liveSocket.emit("startGame", {});
            liveSocket.on("start", (data) => {
              setUserData(data);
            });
          }, 1000);
        }
      });
      return () => {
        liveSocket.disconnect();
      };
    }
  }, []);

  useEffect(() => {
    if (isDemoMode) return;
    socketRef.current?.on("user", (user) => {
      if (user && Object?.values(user)?.length > 0) {
        setUserData(user);
      }
    });
  }, [socketRef?.current]);

  useEffect(() => {
    if (isDemoMode) return;
    axios
      .get(`${adminBaseURL + "setting"}`)
      .then((res) => {
        setSettingData(res?.data?.setting);
        if (res?.data?.setting?.gameCoin) {
          setGameCoin(res?.data?.setting?.gameCoin);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <div className="game-page">
      <WheelContent
        userData={userData}
        socket={isDemoMode ? socket : socketRef.current}
        settingData={settingData}
        gameCoin={gameCoin}
      />
      <ToastContainer />
    </div>
  );
}

export default App;
